export class AsyncJob {
	constructor() {
		this._total = 0;
		this._completed = 0;
		this._results = [];
		this._error = null;
		this._isFinished = false;
		this._execCallback = null;
	}

	callback(key) {
		const that = this;
		const index = this._total;
		this._total++;
		let calledThisCallback = false;

		return (err, res) => {
			if (that._isFinished || calledThisCallback) {
				return;
			}

			calledThisCallback = true;
			that._completed++;

			if (err) {
				that._error = err;

			} else {
				that._results[index] = res;
				if (key) {
					that._results[key] = res;
				}
			}

			that._tryFinish();
		};
	}

	wait(execCallback) {
		if (this._isFinished) {
			return;
		}

		this._execCallback = execCallback;
		this._tryFinish();
	}

	_tryFinish() {
		if (this._isFinished || !this._execCallback) {
			return;
		}

		if (this._error) {
			this._isFinished = true;
			return this._execCallback(this._error);
		}

		if (this._completed >= this._total) {
			this._isFinished = true;
			this._execCallback(null, this._results);
		}
	}
}

/**
 * @returns {AsyncJob}
 */
export default function async() {
	return new AsyncJob();
}
